<template>
  <prime-dialog
    :visible="modelValue"
    :header="header"
    :modal="true"
    :style="{ width: '85%', maxHeight: '85vh' }"
    :contentStyle="{ overflowY: 'auto' }"
    @update:visible="$emit('update:modelValue', $event)"
  >
    <div v-if="message" class="contact-impact-message">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <span>{{ message }}</span>
    </div>

    <div class="contact-impact-sections" :class="{ 'with-changes': changes.length > 0 }">
      <section v-if="changes.length" class="contact-impact-changes">
        <h5>Elenco modifiche</h5>
        <div v-for="change in changes" :key="change.field" class="contact-change-row">
          <strong>{{ change.label }}</strong>
          <div class="contact-change-values">
            <span class="contact-change-old">{{ change.oldValue }}</span>
            <i class="pi pi-arrow-right" aria-hidden="true"></i>
            <span class="contact-change-new">{{ change.newValue }}</span>
          </div>
        </div>
      </section>

      <ContactAssociationsDisplay
        v-if="hasAssociations"
        :contact="contact"
        :contracts-header="contractsHeader"
        :inline-with-siblings="changes.length > 0"
      />
    </div>

    <template v-if="confirmable" #footer>
      <prime-button :label="rejectLabel" class="p-button-text" @click="cancel" />
      <prime-button :label="acceptLabel" class="p-button-primary" @click="confirm" />
    </template>
  </prime-dialog>
</template>

<script>
import PrimeButton from "primevue/button";
import PrimeDialog from "primevue/dialog";
import ContactAssociationsDisplay from "@/components/ask/details/ContactAssociationsDisplay.vue";

export default {
  name: "ContactImpactDialog",
  components: { PrimeButton, PrimeDialog, ContactAssociationsDisplay },
  props: {
    modelValue: { type: Boolean, default: false },
    header: { type: String, default: "Associazioni del contatto" },
    message: { type: String, default: "" },
    changes: { type: Array, default: () => [] },
    contact: { type: Object, default: () => ({}) },
    contractsHeader: { type: String, default: "Contratti interessati" },
    confirmable: { type: Boolean, default: false },
    acceptLabel: { type: String, default: "Conferma" },
    rejectLabel: { type: String, default: "Annulla" },
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  computed: {
    hasAssociations() {
      return Boolean(this.contact?.contratti?.length || this.contact?.caricamenti?.length);
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm");
      this.$emit("update:modelValue", false);
    },
    cancel() {
      this.$emit("cancel");
      this.$emit("update:modelValue", false);
    },
  },
};
</script>

<style scoped>
.contact-impact-message {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}
.contact-impact-sections {
  display: block;
}
.contact-impact-changes {
  max-height: calc(85vh - 14rem);
  padding: 1rem;
  border: 1px solid var(--surface-border);
  border-radius: 6px;
  background: var(--surface-50);
  overflow-y: auto;
}
.contact-impact-changes h5 {
  margin: 0 0 0.75rem;
}
.contact-change-row + .contact-change-row {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--surface-border);
}
.contact-change-values {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 0.75rem;
  align-items: center;
  margin-top: 0.35rem;
}
.contact-change-old {
  color: var(--text-color-secondary);
  text-decoration: line-through;
}
.contact-change-new {
  color: var(--primary-color);
  font-weight: 600;
}
@media screen and (min-width: 1024px) {
  .contact-impact-sections.with-changes {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: start;
    gap: 1rem;
  }
}
</style>
